import type React from 'react';
import { Button, Modal } from 'shared-portal-components-v2';

import type { FileUploadDialogV2Props } from './FileUploadDialogV2.types';
import FileUploadDropZone from './FileUploadDropZone';
import FileUploadFileList from './FileUploadFileList';
import FileUploadProgressView from './FileUploadProgressView';

export default function FileUploadDialogV2({
  isOpen,
  step,
  files,
  encryptionSteps,
  uploadedFileCount,
  isUploadDisabled,
  onClose,
  onFilesAdded,
  onFileRemoved,
  onUpload,
  onDone,
  maxSize,
  accept,
}: FileUploadDialogV2Props): React.JSX.Element | null {
  const isProgressStep = step === 'progress';
  const hasFiles = files.length > 0;

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Upload Files"
      panelClassName="sm:max-w-2xl w-full max-h-[min(90vh,48rem)] flex flex-col"
      isOverlayClickDisabled={isProgressStep}
      isEscapeKeyDisabled={isProgressStep}
      isCloseIconVisible={!isProgressStep}
    >
      <div className="flex-1 min-h-0 overflow-y-auto pr-1">
        {isProgressStep ? (
          <FileUploadProgressView
            encryptionSteps={encryptionSteps}
            uploadedFileCount={uploadedFileCount}
            onDone={onDone}
          />
        ) : (
          <div className="space-y-4">
            <FileUploadDropZone onFilesAdded={onFilesAdded} maxSize={maxSize} accept={accept} />

            {hasFiles ? <FileUploadFileList files={files} onFileRemoved={onFileRemoved} /> : null}
            <div className="sticky bottom-0 flex flex-col-reverse gap-2 bg-background pt-2 sm:flex-row sm:justify-end sm:space-x-2 sm:gap-0">
              <Button variant="outline" size="md" onClick={onClose}>
                Cancel
              </Button>
              <Button
                variant="primary"
                size="md"
                onClick={onUpload}
                disabled={isUploadDisabled || !hasFiles}
                className="h-12"
              >
                Upload {files.length} Files
              </Button>
            </div>
          </div>
        )}
      </div>
    </Modal>
  );
}
